import { DEPARTMENT } from '@/models/departments';

export const ORIGIN = `${process.env.VUE_APP_ORIGIN}`;
export const FEATURES = {
  HIDE_OBSOLETE_FOLDERS: 'HIDE_OBSOLETE_FOLDERS',
  GPT: 'GPT',
  CUSTOMER_INFO: 'CUSTOMER_INFO',
};
export const MONTHS = [
  'Cічень',
  'Лютий',
  'Березень',
  'Квітень',
  'Травень',
  'Червень',
  'Липень',
  'Серпень',
  'Вересень',
  'Жовтень',
  'Листопад',
  'Грудень',
];

export const BLOB_CONTAINER_URL = `${process.env.VUE_APP_BLOB_URL}${process.env.VUE_APP_BLOB_CONTAINER_NAME}/`;

export const OBSOLETE_FOLDER_IDS = [
  'sheriff',
  'leadFollowUp',
  'archiveFinances',
  'archiveLegalization',
  'archiveLegalizationDocuments',
  'archiveRegister',
  'archiveLeadFollowUp',
];

/* 
  unique sort order specific for folders bar
  items present in map will be pushed towards the start
  of the list in the same order they are defined here
 */
export const FOLDERS_BAR_DEPARTMENT_ORDER_MAP = new Map(
  [
    DEPARTMENT.LEAD_FOLLOW_UP,
    DEPARTMENT.SURVEY,
    DEPARTMENT.FINANCES,
    DEPARTMENT.ASSIGN_ID,
    DEPARTMENT.INVOICE,
  ].map((key, index) => [key, index])
);

export const LEAD_FOLLOW_UP_VOTE_OPTION = {
  CLARIFICATION: 'clarification',
  CONDITIONS: 'conditions',
  CONSULTATION: 'consultation',
  NOT_INTERESTED: 'notInterested',
};

export const EVENT = {
  HOURLY_CHAT_STATISTICS: 'hourlyChatStatistics',
  DEPARTMENT_ADD: 'departmentAdd',
  DEPARTMENT_REMOVE: 'departmentRemove',
  CHAT_ACTION_START: 'chatActionStart',
  CHAT_ACTION_END: 'chatActionEnd',
  CHAT_ENTER: 'chatEnter',
  CHAT_EXIT: 'chatExit',
  CALL_REQUEST: 'callRequest',
};

export const DATE_RANGE = {
  DAY: 'day',
  MONTH: 'month',
};

export const SUPPORT_DECISION = {
  YES: 'yes',
  NO: 'no',
  EDIT: 'edit',
};

export const GPT_SUGGESTION_SOURCE = {
  GPT_COMPLETION: 'gpt-completion',
  GPT_AUTO_COMPLETION: 'gpt-auto-completion',
};

export const GPT_SUPPORT_ID = 'gpt';
export const SYSTEM_SUPPORT_ID = 'system';
